import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from '@/utils/format';
import type { FacilityAgreement, Applicant, Consumer, CancelRequest } from "../types";
import InfoDisplay from "@/components/InfoDisplay";
import SidebarNavigation from "@/components/SidebarNavigation";
import Layout from "../../shared/components/Layout";
import type { CancelRequestParams } from "../types";
import clearLocalStorage from "@/utils/clearLocalStorage";
import createCancel from "../api/createCancel";

const CancelConfirm: React.FC = () => {
  const { custCode } = useParams();

  const navigate = useNavigate();

  const [facilityAgreement, setFacilityAgreement] = useState<FacilityAgreement>();
  const [applicant, setApplicant] = useState<Applicant>();
  const [consumer, setConsumer] = useState<Consumer>();
  const[cancelRequest, setCancelRequest] = useState<CancelRequest>({
    lensCollectionDate: ""
  })

  useEffect(() => {
    const storedApplicant = localStorage.getItem("applicant");
    if(storedApplicant) {
      setApplicant(JSON.parse(storedApplicant));
    }

    const storedConsumer = localStorage.getItem("consumer");
    if(storedConsumer) {
      setConsumer(JSON.parse(storedConsumer));
    }

    const storedFacilityAgreement = localStorage.getItem("facilityAgreement");
    if(storedFacilityAgreement) {
      setFacilityAgreement(JSON.parse(storedFacilityAgreement));
    }

    const storedCancelRequest = localStorage.getItem("cancelRequest");
    if(storedCancelRequest) {
      setCancelRequest(JSON.parse(storedCancelRequest));
    }

  }, []);

  const handleSubmit = async (e: React.MouseEvent<HTMLFormElement>) => {
    e.preventDefault()
    const params: CancelRequestParams = {
      cancelRequest: cancelRequest
    }

    try {
      const res = await createCancel(params, custCode);
      if(res.status === 201) {
        clearLocalStorage();

        navigate(`/facility/facility_agreements/terminate_cancels/${custCode}/cancel/complete`);
      } else if(res.status !== 201) {
        navigate(`/facility/facility_agreements/terminate_cancels/${custCode}/cancel`);
        window.scrollTo(0, 0)
        console.error(`status: ${res.status}, message: ${res.statusText}`);
      }

    } catch (err: any) {
      navigate(`/facility/facility_agreements/terminate_cancels/${custCode}/cancel`);
      window.scrollTo(0, 0);
      console.log('An unexpected error occurred:', err.message);
    }
  }

  const renderPreviousPage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    navigate(`/facility/facility_agreements/terminate_cancels/${custCode}/cancel`, { state: { fromConfirmPage: true } });
    window.scrollTo(0, 0);
  }

  const displayPlan = (plan: string): string => {
    if(plan === 'both') return "両眼プラン"
    if(plan === 'right') return "片眼プラン(右眼)"
    if(plan === 'left') return "片眼プラン(左眼)"
    return '';
  }

  return (
    <Layout>
      <main className="wrapper" id="page-facility_login">
        <section className="sec-contact">
          <div className="inner">
            <h1 className="c-ttl__01">キャンセル申込入力確認</h1>
            <div className="contact-box">
              <div className="contact-box__left">
                <div className="mbpc-98 mbsp-32">
                  <form onSubmit={handleSubmit}>
                    <div className="contact-box__form js-item" id="id-01">
                      <h2 className="c-ttl__02">お客様情報</h2>
                      <InfoDisplay label="契約種別" value={"定額制契約"} />
                      <InfoDisplay label="お客様ID" value={custCode} />
                      <InfoDisplay label="申込者名(カナ)" value={applicant?.nameKana} />
                      <InfoDisplay label="レンズ使用者名(カナ)" value={consumer?.nameKana} />
                    </div>
                    <div className="contact-box__form mbsp-29 js-item h-adr" id="id-02">
                      <h2 className="c-ttl__02">契約詳細</h2>
                      <InfoDisplay label="ご契約プラン" value={displayPlan(facilityAgreement?.plan ?? '')} />
                      <InfoDisplay label="サービス利用開始日" value={formatDate(facilityAgreement?.startDate ?? '')} />
                      <InfoDisplay label={<>レンズ回収日<br/>(キャンセル申込日)</>} value={formatDate(cancelRequest.lensCollectionDate)} />
                    </div>
                    <button type="submit" className="c-btn__01">入力内容の確認</button>
                  </form>
                  <div className="c-al--c">
                    <button className="c-btn__02" onClick={renderPreviousPage}>前のページに戻る</button>
                  </div>
                </div>
              </div>
              <SidebarNavigation items={[
                { id: "id-01", label: "お客様情報" },
                { id: "id-02", label: "契約詳細" },
                ]} />
            </div>
          </div>
        </section>
      </main>
    </Layout>
  )
}

export default CancelConfirm;